import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import { useDispatch, useSelector } from "react-redux";
import {
  getGoogleReview,
  setGoogleReview,
} from "../../../../reduxToolkit/features/adminPanel/webSettings";

// Icon
import CheckIcon from "@mui/icons-material/Check";
import { Grid, IconButton, Tooltip } from "@mui/material";

export default function ManageGoogleReview() {
  const dispatch = useDispatch();
  const { googleReview } = useSelector((state) => state.webSettings);

  const [reviewCountMfw, setReviewCountMfw] = useState(20);
  const [reviewUrlMfw, setReviewUrlMfw] = useState("");
  const [reviewCountElife, setReviewCountElife] = useState(20);
  const [reviewUrlElife, setReviewUrlElife] = useState("");

  const handleMfwReviewCountChange = (e) => {
    // setReviewCountMfw(e.target.value.replace(/\D/g, ""));
    setReviewCountMfw(e.target.value);
  };

  const handleMfwReviewCountConfirm = () => {
    dispatch(setGoogleReview({ reviewCountMfw: reviewCountMfw }));
    setTimeout(() => {
      dispatch(getGoogleReview());
    }, 1000);
  };

  const handleMfwReviewUrlChange = (e) => {
    setReviewUrlMfw(e.target.value);
  };

  const handleMfwReviewUrlConfirm = () => {
    dispatch(setGoogleReview({ reviewUrlMfw: reviewUrlMfw }));
    setTimeout(() => {
      dispatch(getGoogleReview());
    }, 1000);
  };

  const handleElifeReviewCountChange = (e) => {
    // setReviewCountElife(e.target.value.replace(/\D/g, ""));
    setReviewCountElife(e.target.value);
  };

  const handleElifeReviewCountConfirm = () => {
    dispatch(setGoogleReview({ reviewCountElife: reviewCountElife }));
    setTimeout(() => {
      dispatch(getGoogleReview());
    }, 1000);
  };

  const handleElifeReviewUrlChange = (e) => {
    setReviewUrlElife(e.target.value);
  };

  const handleElifeReviewUrlConfirm = () => {
    dispatch(setGoogleReview({ reviewUrlElife: reviewUrlElife }));
    setTimeout(() => {
      dispatch(getGoogleReview());
    }, 1000);
  };

  // useEffect
  useEffect(() => {
    dispatch(getGoogleReview());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Store

  useEffect(() => {
    if (googleReview !== undefined) {
      setReviewCountMfw(googleReview.googleReviewCountMfw);
      setReviewUrlMfw(googleReview.googleReviewUrlMfw);
      setReviewCountElife(googleReview.googleReviewCountElife);
      setReviewUrlElife(googleReview.googleReviewUrlElife);
    }
  }, [googleReview]);
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid container>
          <Grid item>
            <TextField
              label="MFW Google Review Count"
              value={reviewCountMfw}
              onChange={handleMfwReviewCountChange}
              size="small"
              variant="standard"
            />
          </Grid>
          <Grid item>
            <Tooltip arrow placement="top" title="Confirm">
              <IconButton
                size="'small"
                disabled={reviewCountMfw !== "" ? false : true}
                onClick={handleMfwReviewCountConfirm}
                sx={{ mt: 0.8 }}
              >
                <CheckIcon
                  color={reviewCountMfw !== "" ? "success" : "inherit"}
                />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid container>
          <Grid item>
            <TextField
              label="MFW Google Review URL"
              value={reviewUrlMfw}
              onChange={handleMfwReviewUrlChange}
              size="small"
              variant="standard"
            />
          </Grid>
          <Grid item>
            <Tooltip arrow placement="top" title="Confirm">
              <IconButton
                size="'small"
                disabled={reviewUrlMfw !== "" ? false : true}
                onClick={handleMfwReviewUrlConfirm}
                sx={{ mt: 0.8 }}
              >
                <CheckIcon
                  color={reviewUrlMfw !== "" ? "success" : "inherit"}
                />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid container>
          <Grid item>
            <TextField
              label="ELife Google Review Count"
              value={reviewCountElife}
              onChange={handleElifeReviewCountChange}
              size="small"
              variant="standard"
            />
          </Grid>
          <Grid item>
            <Tooltip arrow placement="top" title="Confirm">
              <IconButton
                size="'small"
                disabled={reviewCountElife !== "" ? false : true}
                onClick={handleElifeReviewCountConfirm}
                sx={{ mt: 0.8 }}
              >
                <CheckIcon
                  color={reviewCountElife !== "" ? "success" : "inherit"}
                />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={6}>
        <Grid container>
          <Grid item>
            <TextField
              label="Elife Google Review URL"
              value={reviewUrlElife}
              onChange={handleElifeReviewUrlChange}
              size="small"
              variant="standard"
            />
          </Grid>
          <Grid item>
            <Tooltip arrow placement="top" title="Confirm">
              <IconButton
                size="'small"
                disabled={reviewUrlElife !== "" ? false : true}
                onClick={handleElifeReviewUrlConfirm}
                sx={{ mt: 0.8 }}
              >
                <CheckIcon
                  color={reviewUrlElife !== "" ? "success" : "inherit"}
                />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
